import AddCardIcon from '@mui/icons-material/AddCard';
import { Box, Typography } from '@mui/material';
import React from 'react';
import Button from '@shared/components/Buttons/Button';

interface IntelligenceRequestEmptyStateProps {
  handleCreateIntelligenceRequest: () => void;
  manageMode?: boolean;
  private?: boolean;
}

function IntelligenceRequestEmptyState(props: IntelligenceRequestEmptyStateProps) {
  const { handleCreateIntelligenceRequest } = props;
  return (
    <Box
      sx={{
        border: '2px dashed #c05a3a',
        background: '#faf8f4',
        p: 6,
        textAlign: 'center',
        borderRadius: '12px',
        mt: 4,
      }}
    >
      <AddCardIcon sx={{ color: '#c05a3a', fontSize: 48, mb: 2 }} />
      <Typography
        variant="h5"
        sx={{
          color: '#2a2018',
          fontWeight: 700,
          maxWidth: '100%',
          mb: 1,
        }}
      >
        No Intelligence Requests Yet
      </Typography>
      {props.manageMode
        ? (
            <>
              <Typography sx={{ color: '#8a7d6e', maxWidth: '100%', mb: 3 }}>
                You haven't created any intelligence requests. Get started and gather
                valuable insights tailored to your needs.
              </Typography>
              <Button
                size="large"
                startIcon={<AddCardIcon />}
                onClick={handleCreateIntelligenceRequest}
              >
                Create Intelligence Request
              </Button>
            </>
          )
        : (
            <Typography sx={{ color: '#8a7d6e', mb: 3 }}>
              No Intelligence Requests available at the moment.
            </Typography>
          )}

    </Box>
  );
}

export default IntelligenceRequestEmptyState;
